import React, { useCallback, useEffect, useState } from "react";
import "../../App.css";
import "../../profile.css";

import { ArrowLeft, Calendar, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const CreateGroup = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [teamName, setTeamName] = useState("");
  const [challengeId, setChallengeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [challenges, setChallenges] = useState([]);

  const fetchChallenges = useCallback(async () => {
    try {
      const res = await service.get(
        endpoints.teammanagment.challengeslist,
        {},
        { skipToast: true },
      );
      console.log(res.data.data);
      setChallenges(res.data.data || []);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchChallenges();
  }, [fetchChallenges]);

  const handleCreateGroup = async () => {
    if (!teamName.trim()) {
      return;
    }
    if (!challengeId) {
      return;
    }

    const payload = {
      teamName: teamName.trim(),
      challengeId: parseInt(challengeId),
      startDate: startDate,
      startTime: startTime,
    };

    try {
      setLoading(true);
      const res = await service.post(
        endpoints.teammanagment.createteam,
        payload,
      );
      navigate("/team-management");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="group-page">
      <div className="group-title-page">
        <ArrowLeft className="cursor" onClick={() => navigate(-1)} />
        <h2>Create Group</h2>
      </div>

      <div className="group-form">
        <div className="form-group">
          <label>Group Name</label>
          <input
            type="text"
            placeholder="Enter Your Name"
            value={teamName}
            onChange={(e) => setTeamName(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Select Challenge</label>
          <div className="input-icon">
            <select
              value={challengeId}
              onChange={(e) => setChallengeId(e.target.value)}
            >
              <option value="">Select a challenge</option>
              {challenges.map((item) => (
                <option key={item.userChallengeId} value={item.challengeId}>
                  {item.challengeName}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* <div className="form-group">
//           <label>Select Challenge Type</label>

//           <select>
//             <option>Collaborative</option>
//           </select>
//         </div> */}

        <div className="form-group">
          <label>Date</label>
          <div
            className="input-icon"
            onClick={() => document.getElementById("dateInput").showPicker()}
          >
            <input
              id="dateInput"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{ cursor: "pointer" }}
            />
            <Calendar size={18} style={{ cursor: "pointer" }} />
          </div>
        </div>

        <div className="form-group">
          <label>Time</label>
          <div
            className="input-icon"
            onClick={() => document.getElementById("timeInput").showPicker()}
          >
            <input
              id="timeInput"
              type="time"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              style={{ cursor: "pointer" }}
            />
            <Clock size={18} style={{ cursor: "pointer" }} />
          </div>
        </div>

        <button
          className="red-btn form-btn"
          onClick={handleCreateGroup}
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Group"}
        </button>
      </div>
    </div>
  );
};

export default CreateGroup;
